// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"2ec2bc38","126":"abdf082a","171":"18026c45","220":"039b0b92","453":"174c4f4d","842":"20c101a3","940":"1ed31404","998":"9a59ec5a"}[chunkId] + ".chunk.js";
};